import { preventReClick } from "./preventReClick.js";
export default {
  install(Vue, options) {
    Vue.use(preventReClick);
  }
};
